import { Grid } from "@mui/material";
import React from "react";

import NewsComponent from "../components/News/NewsComponent";

const News = () => {
    
  return (
      <>
      
      <NewsComponent  />
      
      </>
  )
};

export default News;
